export const APPLICATION_MODES = ['empty', 'viewer', 'editor', 'composition'] as const;

export const VISIBLE_APPLICATION_MODES = ['viewer', 'editor', 'composition'] as const;

export type ApplicationMode = (typeof APPLICATION_MODES)[number];
export type OpenInputKind = 'project' | 'spatial-data';

const allowedTransitions: Readonly<Record<ApplicationMode, readonly ApplicationMode[]>> = {
  empty: ['viewer', 'editor'],
  viewer: ['empty', 'editor', 'composition'],
  editor: ['empty', 'viewer', 'composition'],
  composition: ['empty', 'viewer', 'editor'],
};

export function canTransitionMode(from: ApplicationMode, to: ApplicationMode): boolean {
  return from === to || allowedTransitions[from].includes(to);
}

export function modeForOpenedInput(input: OpenInputKind): ApplicationMode {
  return input === 'project' ? 'viewer' : 'editor';
}
